/* eslint-disable object-shorthand */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// // api
import { signinWithPW } from '../../services/apis/auth';
import {
	getUserInfoFromAlcohol,
	postUserLoginHistoryToAlcohol,
} from '../../services/apis/alcohol/user';
import {
	getUserInfoFromHearro,
	postUserLoginHistoryToHearro,
} from '../../services/apis/hearro/user';
import { getUserInfoFromMomthera } from '../../services/apis/momthera/user';
import getSystemMessageFromHearro from '../../services/apis/hearro/systemMessage';

// // components
import CommonModal from '../../components/modal/CommonModal';
import ProjectInfo from './ProjectSpec';
import { useSystemMessage } from '../../contexts/SystemMessageContext';

function SignInPageV2({ title, type }) {
	const [id, setId] = useState(localStorage.getItem('saveId') || '');
	const [pw, setPw] = useState('');

	const [saveId, setSaveId] = useState(!!localStorage.getItem('saveId'));

	const [showFailModal, setShowFailModal] = useState(false);

	const [showEmptyModal, setShowEmptyModal] = useState(false);

	const navigate = useNavigate();
	const { showMessage } = useSystemMessage();
	const defaultMessage = '인가되지 않은 시스템 사용은 금지되며 민·형사상의 처벌 대상입니다.';

	const triggerSystemMessage = async () => {
		const hasShownToast = sessionStorage.getItem('hasShownLoginToast');
		if (hasShownToast) return;

		let msg = defaultMessage;
		try {
			const res = await getSystemMessageFromHearro();
			if (parseInt(res.status / 200, 10) === 1 && typeof res.data === 'string') {
				msg = res.data;
			}
		} catch (e) {
			// ignore and use defaultMessage
		}
		showMessage(msg, 2000);
		sessionStorage.setItem('hasShownLoginToast', 'true');
	};
	// 로그인 시도
	async function trySignIn() {
		if (!id || !pw) {
			setShowEmptyModal(true);
			return;
		}

		try {
			const request = {
				username: id,
				password: pw,
			};

			const res = await signinWithPW(request);

			if (parseInt(res.status / 200, 10) === 1) {
				localStorage.setItem(`${type}token`, JSON.stringify(res.data));
				let resInfo;
				if (type === 'dtx001') {
					resInfo = await getUserInfoFromAlcohol();
				} else if (type === 'dtx002') {
					resInfo = await getUserInfoFromHearro();
				} else if (type === 'dtx006') {
					resInfo = await getUserInfoFromMomthera();
				}

				if (parseInt(resInfo.status / 200, 10) === 1) {
					// 임시 비밀번호로 로그인한 경우 -> 비밀번호 변경 페이지로 이동
					if (res.data.alertCode === 'Initial-Password-Change-Required') {
						if (type !== 'dtx006') alert('초기 비밀번호를 변경해 주십시오.');
						sessionStorage.setItem('loginID', id);
						navigate(`/change-pw/${type}/initial`);
						return;
					}

					// 정상 로그인
					if (type === 'dtx001') {
						await postUserLoginHistoryToAlcohol();
						triggerSystemMessage(type);
						navigate('/dtx001/dashboard');
					} else if (type === 'dtx002') {
						await postUserLoginHistoryToHearro();
						triggerSystemMessage(type);
						navigate('/dtx002/patient-manage/list');
					} else if (type === 'dtx006') {
						// 추후 맘테라 임상 끝나면 주석 제거
						// triggerSystemMessage(type);
						navigate('/dtx006/dashboard');
					}
				} else {
					localStorage.removeItem(`${type}token`);
					setShowFailModal(true);
				}
				// 비밀번호 변경 6개월이 경과된 경우 -> 비밀번호 변경 페이지로 이동
			} else if (
				res.response &&
				res.response.status === 401 &&
				res.response.data.code === 'Password-Replacement-Required'
			) {
				if (type !== 'dtx006') alert(res.response.data.message);
				sessionStorage.setItem('loginID', id);
				navigate(`/change-pw/${type}/month6`);
			} else {
				setShowFailModal(true);
			}
		} catch (err) {
			console.error(err);
			setShowFailModal(true);
		}
		// 승인 대기중인 상태도 있는듯? 아마 401 에러였던듯? 경로는 fail로 하면 해당 페이지 있음. 필요한 로직인가?
	}

	const handleKeyDown = event => {
		if (event.key.toLowerCase() === 'enter') {
			trySignIn();
		}
	};

	const SignInFailModalHeader = (
		<div className="signinModal__header">
			<p>로그인</p>
		</div>
	);

	const SignInFailModalBody = (
		<div className="signinModal__body">
			<p>{type === 'dtx006' ? '아이디와 비밀번호가 일치하지 않습니다.' : '회원이 아닙니다.'}</p>
			<button onClick={() => setShowFailModal(false)}>확인</button>
		</div>
	);

	const SignInEmptyModalHeader = (
		<div className="signinModal__header">
			<p>로그인</p>
		</div>
	);

	const SignInEmptyModalBody = (
		<div className="signinModal__body">
			<p>아이디와 비밀번호를 확인해주세요.</p>
			<button onClick={() => setShowEmptyModal(false)}>확인</button>
		</div>
	);

	const handleChangeSaveId = e => {
		if (e.target.checked) {
			localStorage.setItem('saveId', id);
		} else {
			localStorage.removeItem('saveId');
		}
		setSaveId(e.target.checked);
	};

	useEffect(() => {
		if (saveId) {
			localStorage.setItem('saveId', id);
		}
	}, [id]);

	return (
		// root
		<div style={{ overflowY: 'auto', height: '100vh' }}>
			<div className="mainContainer">
				{/* 프로젝트 정보란 */}
				<ProjectInfo type={type} title={title} />
				{/* 로그인란 */}
				<div className="signInSection">
					<div className="signInTitleLabel">
						<span>로그인</span>
					</div>
					<div className="signFormRow">
						<div className="signFormInput">
							<input
								type="text"
								placeholder="아이디를 입력해주세요"
								value={id}
								onChange={e => {
									setId(e.target.value);
								}}
								onKeyDown={handleKeyDown}
							/>
						</div>
					</div>
					<div className="signFormRow">
						<div className="signFormInput">
							<input
								type="password"
								placeholder="비밀번호를 입력해주세요"
								value={pw}
								onChange={e => {
									setPw(e.target.value);
								}}
								onKeyDown={handleKeyDown}
							/>
						</div>
					</div>

					<div className="signFormRow">
						<div className="signFormCheckbox">
							<input
								id="save_id"
								type="checkbox"
								checked={!!saveId}
								onChange={handleChangeSaveId}
							/>
							<label htmlFor="save_id">아이디 저장</label>
						</div>
					</div>
					<div className="signFormRow">
						<button className="submitButton" onClick={trySignIn}>
							로그인
						</button>
					</div>
					<div className="linkWrapper">
						<a href="/search-account/dtx006">아이디와 비밀번호를 잊어버렸다면?</a>
					</div>
					<div className="linkWrapper">
						<a href="/sign-up/dtx006">회원가입</a>
					</div>
					<div className="space" />
				</div>
			</div>
			<CommonModal
				size="sm"
				header={SignInFailModalHeader}
				body={SignInFailModalBody}
				show={showFailModal}
				setClose={() => setShowFailModal(false)}
			/>
			<CommonModal
				size="sm"
				header={SignInEmptyModalHeader}
				body={SignInEmptyModalBody}
				show={showEmptyModal}
				setClose={() => setShowEmptyModal(false)}
			/>
		</div>
	);
}
export default SignInPageV2;
